/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { Store } from '../../core/store/Store';
import { AuthUser } from '../../types/User';
import { UserModel } from '../../models/application/UserModel';

export class AuthStore extends Store {
	private userModel: UserModel = new UserModel();

	public getUser(): AuthUser {
		return this.userModel.getUser();
	}

	public saveUser(user: AuthUser): void {
		this.userModel.setToken(user.token);
		this.userModel.setId(user.id);
		this.userModel.setUsername(user.username);
		this.userModel.setImgUrl(user.imgUrl);
	}

	public removeAuthUser(): void {
		this.userModel.removeAuthUser();
	}

	public getAuthToken(): string {
		return this.userModel.token;
	}

	public getUserId(): string {
		return this.userModel.id;
	}

	public getUsername(): string {
		return this.userModel.username;
	}

	public getImgUrl(): string {
		return this.userModel.imgUrl;
	}

	public setUsername(username: string): void {
		this.userModel.setUsername(username);
	}

	public setImgUrl(imgUrl: string): void {
		this.userModel.setImgUrl('');
		this.userModel.setImgUrl(imgUrl);
	}

	public hasAuthToken(): boolean {
		return this.userModel.token.length !== 0;
	}
}
